var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1082_1460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 38C10 21.4315 23.4315 8 40 8C56.5685 8 70 21.4315 70 38C70 54.5685 56.5685 68 40 68C23.4315 68 10 54.5685 10 38Z",
    fill: "#259F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 38C10.5 21.7076 23.7076 8.5 40 8.5C56.2924 8.5 69.5 21.7076 69.5 38C69.5 54.2924 56.2924 67.5 40 67.5C23.7076 67.5 10.5 54.2924 10.5 38Z",
    stroke: "#259F64"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8943 46.4922L26.8943 46.4922C26.2366 48.0727 25.9827 49.7305 25.9488 51.4292C25.9393 51.9028 26.0371 52.26 26.2666 52.4981C26.4964 52.7364 26.848 52.8449 27.3214 52.8449H39.9228L52.6036 52.8437C53.014 52.8437 53.3483 52.726 53.5726 52.4993C53.7974 52.2721 53.9046 51.9428 53.8746 51.5349L53.8746 51.5348C53.8649 51.4044 53.8555 51.2736 53.846 51.1426C53.7823 50.2575 53.7179 49.3633 53.5424 48.4948C53.0184 45.8853 51.6999 43.7487 49.4994 42.1992C47.5767 40.8381 45.394 40.2026 43.0998 39.9021L43.0997 39.9021C41.3214 39.6729 39.5236 39.6368 37.7376 39.7945C35.831 39.9617 33.9578 40.3301 32.2004 41.1327C29.7546 42.246 27.9383 43.9878 26.8943 46.4922ZM48.816 44.5572L48.8163 44.5575C49.8277 45.4211 50.5783 46.5495 50.9837 47.816C51.1625 48.3764 51.2725 48.9558 51.3833 49.5397C51.428 49.7749 51.4727 50.0109 51.5222 50.2466C51.536 50.346 51.5435 50.4461 51.5447 50.5464L28.2853 50.5569C28.2976 50.4523 28.3088 50.3491 28.3198 50.2468C28.3461 50.0027 28.3718 49.7642 28.4122 49.5265L28.4122 49.5264C28.6469 48.1322 29.1064 46.8442 29.9672 45.6985C30.8278 44.5529 31.9485 43.7412 33.2511 43.1607C34.8178 42.4697 36.4775 42.1683 38.1785 42.0519L38.1791 42.0518C39.9977 41.9056 41.8273 41.9838 43.6268 42.2846C45.5407 42.6244 47.3251 43.2611 48.816 44.5572Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103727
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.924 30.3594C44.9073 29.0152 44.5546 27.8542 43.713 26.8782C42.5316 25.5086 41.0045 24.9912 39.2384 25.2075C37.4731 25.4237 36.1378 26.3281 35.4388 27.9696C34.4746 30.237 34.8199 32.3807 36.4049 34.2586L36.4049 34.2586C38.0965 36.2652 40.9223 36.4699 42.9218 34.7776L44.924 30.3594ZM44.924 30.3594H44.9213L44.9198 30.4096C44.8676 32.1001 44.2797 33.6242 42.9219 34.7775L44.924 30.3594ZM32.6369 30.3106L32.6368 30.3106L32.6369 30.3135C32.7061 32.8703 33.6335 35.0556 35.6863 36.7138L35.6864 36.7138C38.3169 38.8352 42.2339 38.6506 44.6656 36.2991C46.0507 34.9901 46.9276 33.2329 47.1409 31.3391C47.3767 29.4101 47.02 27.5921 45.9093 25.9714L45.9093 25.9714C44.7118 24.2286 43.037 23.2279 40.9507 22.9507C39.0464 22.6971 37.2605 23.0716 35.6841 24.2025C33.6114 25.6851 32.7108 27.7832 32.6369 30.3106Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103727
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1082_1460",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.682353 0 0 0 0 0.529412 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_1460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_1460",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBlanc);
export default __webpack_public_path__ + "static/media/contact_blanc.f97342338cdd432e8cacb098099d4ad3.svg";
export { ForwardRef as ReactComponent };